import React from 'react';
import PropTypes from 'prop-types';

const FrontArrowSvg = ({ status, className = '', ...props }) => {

    function getFillColor(status) {
        switch (status) {
            case 'is-not-started': return "#fafbfc";
            case 'is-skipped': return "#e9eaec";
            case 'is-completed': return "#ecf7ed";
            default: return "#f0f3f6";
        }
    }

    function getBorderColor(status) {
        switch (status) {
            case 'is-not-started': return "#e8ebef";
            case 'is-skipped': return "#DEE3E8";
            case 'is-completed': return "#a8d9ad";
            default: return "#90a5c1";
        }
    }

    return <svg 
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 11 32" 
        fill={getFillColor(status)}
        stroke={getBorderColor(status)}
        className={className}
        {...props}>
            <path d="M0 0.333313H0.104908C0.563923 0.333313 0.990667 0.56942 1.23452 0.9583L10.2225 15.2916C10.4941 15.7248 10.4941 16.2752 10.2225 16.7083L1.23452 31.0416C0.990667 31.4305 0.563923 31.6666 0.104908 31.6666H0" />
        </svg>

};

FrontArrowSvg.propTypes = {
    fill: PropTypes.string,
    stroke: PropTypes.string,
    className: PropTypes.string,
    status: PropTypes.string,
};

export default FrontArrowSvg;